import { useAppSelector } from 'store/hooks';
import { useShowWalkthroughV6 } from './useShowWalkthroughV6';
export const useIsMainAppWalkthroughV6Active = () => {
    const isWalkthroughInProgress = useAppSelector((store) => store.feed.walkthrough?.status === 'in-progress');
    const shouldShowInvestItemsInWalkthroughV6 = useShowWalkthroughV6();
    return isWalkthroughInProgress && shouldShowInvestItemsInWalkthroughV6;
};
